// The installed @martletai/marti-sdk-react version, injected at build from the resolved tarball
// (vite.config define). `typeof` guard so a context without the define degrades to 'dev' rather
// than a ReferenceError. Mirrors the anna demo's sdk-version.ts.
declare const __SDK_VERSION__: string | undefined;

export const SDK_VERSION: string =
  typeof __SDK_VERSION__ === 'string' && __SDK_VERSION__ ? __SDK_VERSION__ : 'dev';
